// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2LVRj","productName":"Table_productName__2cl9N"};